import React, { useEffect } from 'react';

export const useIframeResizeObserver = (targetOrigin = '*') => {
  useEffect(() => {
    const isInIframe = window.self !== window.top;

    if (!isInIframe) return;

    if (!('ResizeObserver' in window)) {
      console.warn('ResizeObserver is not supported in this browser.');
      return;
    }

    const resizeObserver = new ResizeObserver((entries) => {
      for (const entry of entries) {
        const payload = {
          type: 'IFRAME_RESIZE',
          height: entry.contentRect.height,
          width: entry.contentRect.width,
          timestamp: Date.now(),
        };
        window.parent.postMessage(payload, targetOrigin);
      }
    });

    resizeObserver.observe(document.body);

    return () => resizeObserver.disconnect();
  }, [targetOrigin]);
};

export const IframeResizeObserver = ({
  children,
}: {
  children?: React.ReactNode;
}) => {
  useIframeResizeObserver();
  return <>{children}</>;
};
